// Ikony „Uložit filtr ke skupině / k produktu / Smazat filtr k produktu“ v headeru záložky Filtry
// StationGroupLayout, viz doc/plans/group-product-filters.md bod 6. Zobrazují se jen adminovi
// a jen když je otevřená (editovaná) uložená skupina. Uložení k produktu otevírá modál s výběrem
// 1+ produktů, viz SaveProductFilterModal.
import { useState } from 'react'
import { SaveProductFilterModal } from './SaveProductFilterModal'

const BLUE_BTN_CLASS = 'flex items-center gap-0 px-0.5 py-0.5 text-sm leading-none border border-blue-300 text-blue-600 hover:bg-blue-50 disabled:opacity-40 transition-colors'
const RED_BTN_CLASS = 'flex items-center gap-0 px-0.5 py-0.5 text-sm leading-none border border-red-300 text-red-600 hover:bg-red-50 disabled:opacity-40 transition-colors'

export function GroupProductFilterActions({
  hasProductFilter, groupProducts, activeProduct,
  onSaveToGroup, onSaveToProduct, onDeleteProductFilter,
}) {
  const [pending, setPending] = useState(null) // 'group' | 'delete' | null
  const [error, setError] = useState(null)
  const [productModalOpen, setProductModalOpen] = useState(false)

  const run = (key, fn) => async () => {
    setPending(key)
    setError(null)
    try {
      await fn()
    } catch (err) {
      setError(err.message)
    } finally {
      setPending(null)
    }
  }

  return (
    <div className="flex items-center gap-1">
      <button
        title="Uložit filtr ke skupině"
        className={BLUE_BTN_CLASS}
        disabled={pending !== null}
        onClick={run('group', onSaveToGroup)}
      >
        💾📁
      </button>
      <button
        title="Uložit filtr k produktu"
        className={BLUE_BTN_CLASS}
        disabled={pending !== null}
        onClick={() => setProductModalOpen(true)}
      >
        💾📦
      </button>
      <button
        title="Smazat filtr k produktu"
        className={RED_BTN_CLASS}
        disabled={pending !== null || !hasProductFilter}
        onClick={run('delete', onDeleteProductFilter)}
      >
        🗑️
      </button>
      {error && <span className="text-xs text-red-600" title={error}>⚠️</span>}

      {productModalOpen && (
        <SaveProductFilterModal
          groupProducts={groupProducts}
          activeProduct={activeProduct}
          onSave={onSaveToProduct}
          onClose={() => setProductModalOpen(false)}
        />
      )}
    </div>
  )
}
